import React, { useEffect, useState } from 'react';
import { jsPDF } from "jspdf";
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Card, Offcanvas } from 'react-bootstrap';
import { Delete } from '@mui/icons-material';



const Notes = () => {


    const [notes, setNotes] = useState('');
    const [title, setTitle] = useState<string>('');
    const [allNotes, setAllNotes] = useState<any>([]);
    const [show, setShow] = useState(false);
    const [offData, setoffData] = useState<any>({});
    const [selectedIndex, setSelectedIndex] = useState(0);


    const submitNotes = async (e: any) => {
        e.preventDefault();

        const data = {
            Title: title,
            Notes: notes,
            Id: Math.floor(Math.random() * 1000),
            Latter: `${notes.length} Latter`,
        };

        if(title === "" || notes === ""){
          alert('No Results Found');
        }
        else{
            const existingNotes = JSON.parse(localStorage.getItem('notesData') || '[]');


            const updatedNotes = [...existingNotes, data];    
            localStorage.setItem('notesData', JSON.stringify(updatedNotes));
    
    
            alert('Note submitted successfully!');
            setNotes('');
            setTitle('');
            setAllNotes(updatedNotes);
            setSelectedIndex(1);
        }

       


        if(title === title){
            
        }


    };



    const deleteNote = (id: any) => {
        const filteredNotes = allNotes.filter((note: any) => note.Id !== id);
        setAllNotes(filteredNotes);
        localStorage.setItem('notesData', JSON.stringify(filteredNotes));

        if(allNotes.length !== 0){
            setSelectedIndex(0);
        }
    };


    const downloadPDF = (Title: any, Notes: any) => {
        const doc = new jsPDF();
      
        doc.setFontSize(18);
        doc.text(Title, 10, 20);
      
        doc.setFontSize(12);
        doc.text(Notes, 10, 40);
      
        doc.save(`${Title}.pdf`);
      };



    const handleClose = () => setShow(false);

    const PreviewNotes = (Title: any, Notes: any) => {
        setShow(true);
        setoffData({ Title, Notes });
    }



    // useEffect ...

    useEffect(() => {
        const savedNotes = JSON.parse(localStorage.getItem('notesData') || '[]');
        setAllNotes(savedNotes);
       

    }, []);





    return (
        <div>
            <div className='container mt-5'>
                <div className='row row-gap-4'>

                    <div className='col-md-12'>
                        <h1> Notes</h1>
                        <p> Stay organized and never lose a thought again. Our Notes App lets you quickly jot down ideas, tasks, and reminders — anytime, anywhere. With a clean design, easy-to-use interface, and secure storage, your creativity and productivity are always just a tap away. Start simplifying your life today!</p>
                    </div>


                    <div className='col-12'>

                        <Tabs selectedIndex={selectedIndex} onSelect={(index) => setSelectedIndex(index)}>
                            <TabList className="mb-5 ps-0 gap-2">
                                <Tab>Online Notepad</Tab>
                                {allNotes.length !== 0 && <Tab>All Notes</Tab>}
                            </TabList>

                            <TabPanel>
                                <form onSubmit={submitNotes}>
                                    <input type="text" className="form-control mb-4" id="title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Enter Notes title" />
                                    <textarea className="form-control mt-2" placeholder='Enter Your Notes...' value={notes} onChange={(e) => setNotes(e.target.value)} rows={12} id="comment" name="text"></textarea>

                                    <div className=' d-flex align-items-center justify-content-end'>
                                        <p className='mb-0'>Latter: {notes.length}</p>
                                    </div>

                                    <button type="submit" className="btn btn-primary mt-3">Save</button>
                                </form>
                            </TabPanel>
                            <TabPanel>

                                <div className='__notes-preview'>
                                    <div className='row row-gap-4'>
                                        {allNotes.map((val: any, i: any) => (
                                            <div className='col-md-4' key={i}>
                                                <Card className='h-100'>
                                                    <Card.Header> Preview {i + 1} Notes {val.Count}</Card.Header>
                                                    <Card.Body>
                                                        <Card.Title>{val?.Title}</Card.Title>
                                                        <Card.Text className='mb-4'>
                                                            {val?.Notes}...
                                                        </Card.Text>
                                                        <div className='d-flex justify-content-between align-items-center '>
                                                            <div>
                                                                <button type='button' onClick={() => PreviewNotes(val?.Title, val?.Notes)} className='btn btn-info'>Preview</button>
                                                                <button type='button' onClick={() => downloadPDF(val?.Title, val?.Notes)}  className='btn btn-secondary ms-2'>Download PDF</button>
                                                            </div>

                                                            <button className='btn' onClick={() => deleteNote(val?.Id)}> <Delete/> </button>
                                                        </div>

                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </TabPanel>
                        </Tabs>

                    </div>
                </div>
            </div>


            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Preview Notes</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <h5 className='mb-4'>{offData?.Title}</h5>
                    <p style={{ fontSize: '14px' }}> {offData?.Notes}</p>
                </Offcanvas.Body>
            </Offcanvas>


        </div>
    );
}

export default Notes;
